import { request } from "@/interface/helper";

const str = "nftRecommend";

export const nftRecommend = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/nft/recommend/list" }),
    add: (data) => request({ data, method: "post", url: "/nft/recommend/add" }),
    detail: (data) => request({ data, method: "post", url: "/nft/recommend/detail" }),
    edit: (data) => request({ data, method: "post", url: "/nft/recommend/modify" }),
  },
};
